import React, { Component } from 'react';
import SpotifyWebApi from 'spotify-web-api-js';
import axios from 'axios'; // Importa Axios
import 'bootstrap/dist/css/bootstrap.css';
import TableResult from './TableResult';
import Selected from './Selected';
import './styles.css'

class SearchInput extends Component {
  static CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
  static CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
  
  state = { query: '',
            artists: [],
            loaded: false,
            tracks1: [],
            tracks2: [],
            toShowName: "",
            toShowImg: ""};

  accessSpotifyAPI = (query) => {

    const spotify = new SpotifyWebApi();

    if(spotify.getAccessToken() == null){
      const authOptions = {
        url: 'https://accounts.spotify.com/api/token',
        headers: {
          Authorization: `Basic ${btoa(SearchInput.CLIENT_ID + ':' + SearchInput.CLIENT_SECRET)}`,
        },
        data: 'grant_type=client_credentials',
      };

      axios
      .post(authOptions.url, authOptions.data, { headers: authOptions.headers })
      .then((response) => {
        const token = response.data.access_token;
        //const spotify = new SpotifyWebApi();
        spotify.setAccessToken(token);   
        console.log("got token")
      })
      .catch((error) => {
        console.error(error);
      });
    } else {
      spotify
      .searchArtists(query + " ", { limit: 10, market: "US" }) //CAMBIO MARKET
      .then((data) => {
        // Fai qualcosa con i risultati!
        //console.log('Search results', data.artists.items);
        const artists = data.artists.items;
        this.setState({ artists }, () => {
          //console.log('Artists updated in state:', this.state.artists);
          this.setState({ loaded: true });
        });
        console.log('state', this.state.artists);
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loaded: true });
      });
    }
  };

  handleChange = (e) => {
    this.setState({ query: e.target.value,
    loaded: false });
    e.preventDefault();
    this.accessSpotifyAPI(this.state.query);
  }
  handleSubmit = (e) => {
    this.setState({ query: '' });
  };
  handleArtistSet = (albums, side, id, name, img) => {
      //setTracks1(albums)
      this.props.onFinalArtistSet(albums, side, id, name, img)
  };

  handleLoading = (side, value) => {
    this.props.onFinalLoadingSet(side, value)
  }

  render() {
    return (
      <div>
        <h2>Choose an artist</h2>
        <form>
          <input
            class="form-control"
            type="text"
            onChange={this.handleChange}
            value={this.state.query}
            placeholder="Enter the name of an artist"
            style={{ borderColor: '#8b008b', backgroundColor: "#535353", color: "white" }}
          />
        </form>
        {this.state.loaded ? ( // Controlla se i dati sono stati caricati
          <TableResult results={this.state.artists} side={this.props.side} onSetArtist={this.handleArtistSet} onSetLoading={this.handleLoading}/> // Se sì, renderizza TableResult con i dati
        ) : (
          <div></div>// Se i dati non sono stati caricati, mostra un messaggio di caricamento
        )}

      </div>
    );
  }
}

export default SearchInput;
